module.exports = __webpack_public_path__ + "node_modules/angular-i18n/angular-locale_en-us.js";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=[path][name].[ext]&context=.!./~/angular-i18n/angular-locale_en-us.js
// module id = 400
// module chunks = 0